import React, { useState, useEffect } from "react";
import PersonalDetailsStyles from "./PersonalDetails.styles";
import {
  Autocomplete,
  Box,
  Divider,
  Grid,
  InputLabel,
  TextField,
  Typography,
  Stack,
  Input,
} from "@mui/material";
import profileImg from "../../../../../assets/images/user-default.svg";
import CustomInput from "../../../../../global/components/CustomInput/CustomInput";
import CustomButton from "../../../../../global/components/CustomButton/CustomButton";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../../helpers/methods";
import notifiers from "../../../../../global/constants/NotificationConstants";
import customErrorHandler from "../../../../../utils/customErrorHandler";
import CustomLoader from "../../../../../global/components/CustomLoader/CustomLoader";
import {
  getFinalBodyStructure,
  handleValidation,
  initialState,
  validateInput,
} from "./Validation";
import { getCountry, getState } from "./PersonalDetailsService";
import {
  getProjectDetails,
  addForm,
  getDeveloper,
  getProject,
  updateProjectDetail,
  getPropetyType,
} from "../StepperService";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Container from "./DragThingsToBoxes/Container";
import GenerateCode from "../Personal Details/DragThingsToBoxes/GenerateCode";
import InputIcon from "../../../../../assets/icons/text.svg";
import TextareaIcon from "../../../../../assets/icons/textarea.svg";
import CheckboxIcon from "../../../../../assets/icons/checkbox.svg";
import RadioIcon from "../../../../../assets/icons/radio.svg";
const _ = require("lodash");
let clonedObject = {};

interface CustomProps {
  nextStep?: () => void | undefined;
  userId: String;
  idd: string;
  setIdd: Function;
  fromSettingOrLogout?: any;
  handleCloseAddTeam?: any;
  edit: Boolean;
  editRowData: any;
  newTeamDialogData:any
}
const PersonalDetails = (props: CustomProps) => {
  const classes = PersonalDetailsStyles;
  const [personalDetailState, setPersonalDetailState] = useState<any>(
    initialState({})
  );
  const [addNewTeamDialog, setNewTeamDialog] = useState<boolean>(false);
  const [developerList, setDeveloperName] = useState<any>([]);
  const [projectList, setProjectName] = useState<any>([]);
  const [type, setType] = useState<any>([]);
  const [apiResponse, setApiResponse] = useState(false);
  const [country, setCountry] = useState<any>([]);
  const [state, setState] = useState([]);
  const [items, setItems] = useState<any>([]);
  const [htmlType, setHtmlType] = useState<any>([
    { id: "field1", type: "text", label: "Text Input", icon: InputIcon },
    { id: "field2", type: "select", label: "Select Field", icon: InputIcon },
    { id: "field4", type: "checkbox", label: "Checkbox", icon: CheckboxIcon },
    { id: "field5", type: "radio", label: "Radio Box", icon: RadioIcon },
    {
      id: "field3",
      type: "textarea",
      label: "Long Answer",
      icon: TextareaIcon,
    },
  ]);
  const [inputValue, setInputValue] = useState(personalDetailState?.developerId?.value ?? "");
  useEffect(() => {
    init();

    // setPersonalDetailState(...personalDetailState , ...)?
  }, [props]);

  const handleOnChangeInputField = (event: any) => {
    const name: any = event.target.name;
    const value: any = event.target.value;
    const isGoForward: any = validateInput(name, value);
    if (!isGoForward) return;
    setPersonalDetailState((prevFormData: any) => ({
      ...prevFormData,
      [name]: { error: "", value },
    }));
  };
 
  const handleAutocompleteChange = async (name: string, value: any) => {
    const isGoForward: any = validateInput(name, value);
    if (!isGoForward) return;
    if (["developerId", "projectId", "projecttypeId"].includes(name)) {
      if ("developerId" == name) {
        const projectData = await getProject(value.id);
        customErrorHandler(projectData);
        setProjectName(
          projectData.data.map((i: any) => {
            return { id: i._id, label: i.project_name };
          })
        );
        setPersonalDetailState((prevFormData: any) => ({
          ...prevFormData,
          projectId: {
            error: "",
            value: "",
            id: "",
          },
        }));
      }
      setPersonalDetailState((prevFormData: any) => ({
        ...prevFormData,
        [name]: {
          error: "",
          value: value.label,
          id: value.id,
        },
      }));
    } else {
      setPersonalDetailState((prevFormData: any) => ({
        ...prevFormData,
        [name]: { error: "", value: value.id },
      }));
    }
  };

  const handleCloseAddTeam = () => {
    setNewTeamDialog(false);
  };
  const init = async () => {
    if (props.userId || true) {
      setApiResponse(true);
      try {
        const developerData = await getDeveloper();
        customErrorHandler(developerData);
        setDeveloperName(
          developerData.data.map((i: any) => {
            return { id: i._id, label: i.developer_name };
          })
        );
        const typeData = await getPropetyType();
        setType(
          typeData.data.map((i: any) => {
            return { id: i._id, label: i.name };
          })
        );
        setApiResponse(false);
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(
          isTruthy(error?.message) ? error?.message : notifiers.GENERIC_ERROR
        );
      }
    }
  };

  // submit mepersonalDetailStatethod
  const submitForm = async () => {

    const validatedObject: any = handleValidation(personalDetailState);
    if (
      validatedObject.developerId.error ||
      validatedObject.projecttypeId.error ||
      validatedObject.form_name.error ||
      validatedObject.leadName.error ||
      validatedObject.leadEmail.error ||
      validatedObject.leadPhone.error
    ) {
      setPersonalDetailState({ ...validatedObject });
      return;
    }
    try {
      const body = { ...personalDetailState, dynamicFields: [...items]};

      let b = {...getFinalBodyStructure(body),projectId:props.newTeamDialogData?.data?.projectId};
        const response = await addForm(b);
        if (response?.success) {
          openSuccessNotification(response?.message);
          props.handleCloseAddTeam();
        } else {
          customErrorHandler(response);
        }
    
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error?.message) ? error?.message : notifiers.GENERIC_ERROR
      );
    }
  };
  // console.log(items,"items")

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box sx={classes.personalWrapper}>
          <Grid container>
            <Grid item xs={12}>
              <Box sx={classes.pageInfoHeader}>
                <Typography sx={classes.Heading}>Create A New Form</Typography>
                <Typography sx={classes.text}>
                  Create a new form to get new leads
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} mt={3}>
              <Grid container>
                <Grid item xs={3}>
                  <Box>
                    <CustomInput
                      label="Form Name"
                      placeHolder="Form Name"
                      helperText={personalDetailState?.form_name?.error}
                      error={!!personalDetailState?.form_name?.error?.length}
                      value={personalDetailState?.form_name?.value}
                      onChange={handleOnChangeInputField}
                      name="form_name"
                      type="text"
                    />
                  </Box>
                </Grid>
                <Grid item xs={3} ml={5}>
                  <Box>
                    <Box sx={classes.labelHead}>
                      <label htmlFor="MaritalStatus" style={classes.label}>
                        Developer Name
                      </label>
                    </Box>
                    <Autocomplete
                      disableClearable
                      value={personalDetailState?.developerId?.value ?? ""}
                      inputValue={inputValue}
                      onChange={(event, newValue) => {
                        handleAutocompleteChange("developerId", newValue || "");
                      }}
                      id="controllable-states-demo"
                      options={developerList}
                      sx={classes.autocomplateStyle}
                      onInputChange={(event, newInputValue) => {
                        setInputValue(newInputValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          sx={
                            personalDetailState?.developerId?.value
                              ? classes.autoInputFill
                              : classes.autoInputBlank
                          }
                          helperText={personalDetailState?.developerId?.error}
                          error={!!personalDetailState?.developerId?.error?.length}
                          placeholder="Select Your Developer Name"
                        />
                      )}
                      renderOption={(props, option) => (
                        <li {...props} style={{ fontSize: "14px" }}>
                          <span style={{ display: "none" }}>{option.id}</span>
                          {option.label}
                        </li>
                      )}
                      filterOptions={(options, state) => {
                        const searchTerm = state.inputValue.toLowerCase();
                        return options.filter(option =>
                          option.label.toLowerCase().includes(searchTerm)
                        );
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} mt={3}>
              <Grid container>
                <Grid item xs={3}>
                  <Box sx={classes}>
                    {/* <Box sx={classes.labelHead}>
                      <label htmlFor="ProjectName" style={classes.label}>
                        Project Name
                      </label>
                    </Box> */}
                    <CustomInput
                      label="Project Name"
                      placeHolder="Enter Name"
                      disabled
                    
                      value={props.newTeamDialogData?.data?.project_name}
                      // onChange={handleOnChangeInputField}
                      name="leadName"
                      type="text"
                    />
                    {/* <Autocomplete
                      disableClearable
                      value={personalDetailState?.projectId?.value ?? ""}
                      inputValue={personalDetailState?.projectId?.value ?? ""}
                      onChange={(event: any, newValue: string | null) => {
                        handleAutocompleteChange("projectId", newValue || "");
                      }}
                      id="controllable-states-demo"
                      options={projectList}
                      sx={classes.autocomplateStyle}
                      renderInput={(params) => (
                        <TextField
                          sx={
                            personalDetailState?.projectId?.value
                              ? classes.autoInputFill
                              : classes.autoInputBlank
                          }
                          {...params}
                          helperText={personalDetailState?.projectId?.error}
                          error={
                            !!personalDetailState?.projectId?.error?.length
                          }
                          value={!!personalDetailState?.projectId?.value}
                          placeholder="Select Your Project Name"
                        />
                      )}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} style={{ fontSize: "14px" }}>
                            <span style={{ display: "none" }}>{option.id}</span>
                            {option.label}
                          </li>
                        );
                      }}
                    /> */}
                  </Box>
                </Grid>
                <Grid item xs={3} ml={5}>
                  <Box>
                    <Box sx={classes.labelHead}>
                      <label htmlFor="State" style={classes.label}>
                        Property Type
                      </label>
                    </Box>
                    <Autocomplete
                      disableClearable
                      value={personalDetailState?.projecttypeId?.value ?? ""}
                      inputValue={
                        personalDetailState?.projecttypeId?.value ?? ""
                      }
                      onChange={(event: any, newValue: string | null) => {
                        handleAutocompleteChange(
                          "projecttypeId",
                          newValue || ""
                        );
                      }}
                      id="controllable-states-demo"
                      options={type}
                      sx={classes.autocomplateStyle}
                      renderInput={(params) => (
                        <TextField
                          sx={
                            personalDetailState?.projecttypeId?.value
                              ? classes.autoInputFill
                              : classes.autoInputBlank
                          }
                          {...params}
                          helperText={personalDetailState?.projecttypeId?.error}
                          error={
                            !!personalDetailState?.projecttypeId?.error?.length
                          }
                          value={!!personalDetailState?.projecttypeId?.value}
                          placeholder="Select Your Property Type"
                        />
                      )}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} style={{ fontSize: "14px" }}>
                            <span style={{ display: "none" }}>{option.id}</span>
                            {option.label}
                          </li>
                        );
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} mt={3}>
              <Divider></Divider>
            </Grid>
            <Grid item xs={12} mt={3}>
              <Typography sx={classes.SubHeading}>Lead Details</Typography>
            </Grid>
            <Grid item xs={12} mt={3}>
              <Grid container>
                <Grid item xs={3}>
                  <Box>
                    <CustomInput
                      label="Name"
                      placeHolder="Enter Name"
                      disabled
                      helperText={personalDetailState?.leadName?.error}
                      error={!!personalDetailState?.leadName?.error?.length}
                      value={personalDetailState?.leadName?.value}
                      onChange={handleOnChangeInputField}
                      name="leadName"
                      type="text"
                    />
                  </Box>
                </Grid>
                <Grid item xs={3} ml={5}>
                  <Box>
                    <CustomInput
                      label="Work Email"
                      placeHolder="xyz@xyz.com"
                      disabled
                      helperText={personalDetailState?.leadEmail?.error}
                      // error={!!personalDetailState?.leadEmail?.error?.length}
                      value={personalDetailState?.leadEmail?.value}
                      onChange={handleOnChangeInputField}
                      name="leadEmail"
                      type="text"
                    />
                  </Box>
                </Grid>
                <Grid item xs={3} ml={5}>
                  <Box>
                    <CustomInput
                      label="Phone Number"
                      placeHolder="XXX XXX XXXX"
                      disabled
                      helperText={personalDetailState?.leadPhone?.error}
                      // error={!!personalDetailState?.leadPhone?.error?.length}
                      value={personalDetailState?.leadPhone?.value}
                      onChange={handleOnChangeInputField}
                      name="leadPhone"
                      type="text"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} mt={3}>
              <Divider></Divider>
            </Grid>
            <Grid item xs={12} mt={3}>
              <Typography sx={classes.SubHeading}>
                Additional Details
              </Typography>
              <Typography sx={classes.text}>
                Drag and Drop from Components
              </Typography>
            </Grid>
            <Grid item xs={12} mt={3}>
              <Stack direction="row" spacing={2}>
                <DndProvider backend={HTML5Backend}>
                  <Container
                    htmlType={htmlType}
                    setItems={setItems}
                    items={items}
                  />
                </DndProvider>
              </Stack>
            </Grid>
            <Grid item xs={12} mt={3} mb={3}>
              <Box sx={classes.buttonWrapper}>
                <CustomButton
                  label={`Preview`}
                  onClick={() => setNewTeamDialog(true)}
                  buttonType="secondaryBtn"
                  customClasses={classes.custombuttonStyle}
                />
                <CustomButton
                  label={`${props.userId ? "" : "Save & "}Continue`}
                  onClick={submitForm}
                  buttonType="primaryBtn"
                  customClasses={classes.custombuttonStyle}
                />
              </Box>
            </Grid>
          </Grid>

          {addNewTeamDialog && (
            <GenerateCode
              isDialogOpen={true}
              handleCloseAddTeam={handleCloseAddTeam}
              items={items}
            />
          )}
          {apiResponse && <CustomLoader apiResponse={false} />}
        </Box>
      </Grid>
    </Grid>
  );
};

export default PersonalDetails;
